import type { RouteRecordRaw } from "vue-router"

const buyerPortalRoutes: Array<RouteRecordRaw> = [
  {
    path: "/buyers",
    name: "buyers",
    component: () => import("@/views/lead-distribution/buyer/ManageBuyer.vue"),
    meta: {
      pageTitle: "Buyers",
      breadcrumbs: ["Buyers"],
    },
  },
  {
    path: "/buyers/:buyerId/team",
    name: "buyerTeam",
    component: () => import("@/views/lead-distribution/buyer/BuyerTeam.vue"),
    meta: {
      pageTitle: "Buyer Team",
      breadcrumbs: ["Buyers", "Team Management"],
    },
  },
  {
    path: "/intake-profiles",
    name: "intake-profiles",
    component: () => import("@/views/intake-profile/ManageIntakeProfile.vue"),
    meta: {
      pageTitle: "Intake Profiles",
      breadcrumbs: ["Intake Profiles"],
    },
  },
]

export default buyerPortalRoutes
